import { useAtom } from 'jotai';
import { useCallback, useState } from 'react';
import type { InteractionType } from '@/common/types/interaction';
import {
  interactionsAgentsState,
  useToggleFilter,
} from '@/views/Interactions/state/filters';
import { FilterAutocomplete } from '../../FilterAutocomplete';
import { useAgentAutocompleteOptions } from './useAgentAutocompleteOptions';

interface Props {
  label?: string | null;
  stateKey: string;
  type: InteractionType;
}

export function AgentAutocomplete({ label = 'Agent', stateKey, type }: Props) {
  const [search, setSearch] = useState('');
  const { options, resultsTruncated, isLoading, isSearching, truncatedAt } =
    useAgentAutocompleteOptions({ stateKey, search });

  const [agents, setAgents] = useAtom(interactionsAgentsState(stateKey));
  const toggleAgent = useToggleFilter(stateKey);
  const clearAllAgents = useCallback(() => setAgents([]), [setAgents]);

  return (
    <FilterAutocomplete
      type={type}
      filterType="agents"
      eventContainer="agent_team_filter"
      label={label ?? undefined}
      value={agents}
      options={options}
      inputValue={search}
      onInputChange={setSearch}
      // Only block the field while there is genuinely nothing to show; once
      // options exist, a refetch must not interrupt typing.
      isLoadingOptions={isLoading && options.length === 0}
      isSearching={isSearching}
      alertMessage={
        resultsTruncated
          ? `Showing the first ${truncatedAt} matches — keep typing to narrow the list.`
          : undefined
      }
      onClear={clearAllAgents}
      onToggle={toggleAgent}
    />
  );
}
